import cx from "classnames";
import { type Ref, forwardRef } from "react";
import { t } from "ttag";

import happy from "assets/img/metabot-happy.svg?component";
import sad from "assets/img/metabot-sad.svg?component";
import cool from "assets/img/metabot-shades.svg?component";
import { useSetting } from "metabase/common/hooks";

export type MetabotVariant = "happy" | "sad" | "cool";
import Styles from "./MetabotLogo.module.css";

const urlByVariant = {
  happy,
  sad,
  cool,
};

export interface MetabotLogoProps {
  className?: string;
  variant?: MetabotVariant;
  isCool?: boolean;
}

const MetabotLogo = forwardRef(function MetabotLogo(
  { variant = "happy", className, isCool, ...rest }: MetabotLogoProps,
  ref: Ref<any>,
) {
  const MetabotComponent = urlByVariant[variant];
  const hasSetBrandColor = Boolean(useSetting("application-colors")?.brand);

  return (
    <MetabotComponent
      className={cx(
        hasSetBrandColor ? Styles.MetabotLogoGray : Styles.MetabotLogo,
        className,
      )}
      {...rest}
      ref={ref}
      aria-label={t`Metabot`}
      role="img"
    />
  );
});

// eslint-disable-next-line import/no-default-export -- deprecated usage
export default MetabotLogo;
